import 'react-multi-carousel/lib/styles.css';
import { Container, Row, Col } from "react-bootstrap";
import CodeBlock from "./CodeBlock";
import { useState, useEffect } from "react";

export const AboutMe = () => {
    const images = [
        "/files/img/about-me/diploma.jpg",
        "/files/img/about-me/disney.jpg",
        "/files/img/about-me/oostenrijk.jpg",
        "/files/img/about-me/comic-con-2023.jpeg",
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isGlitching, setIsGlitching] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsGlitching(true);
            setTimeout(() => {
                setCurrentImageIndex((prev) => (prev + 1) % images.length);
                setIsGlitching(false);
            }, 800);
        }, 5000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <section className="about-me" id="about-me">
            <Container>
                <Row>
                    <Col
                        xs={{ order: 2 }}
                        md={{ order: 2 }}
                        xl={{ order: 1, span: 5 }}
                        className="d-flex align-items-center justify-content-center"
                    >
                        <div className="about-me-bx text-center mt-5 mt-xl-0">
                            <div
                                className={`glitch-frame ${isGlitching ? "glitch-on" : ""}`}
                                style={{
                                    backgroundImage: `url("${images[currentImageIndex]}")`,
                                }}
                            ></div>

                            <div className="mt-3">
                                <button
                                    className="me-4"
                                    onClick={() =>
                                        window.open("/documents/CV_Jennifer_Coenraad.pdf", "_blank", "noopener,noreferrer")
                                    }
                                >
                                    <span>Download mijn CV</span>
                                </button>
                            </div>
                        </div>
                    </Col>

                    <Col xs={{ order: 1 }} md={{ order: 1 }} xl={{ order: 2, span: 7 }}>
                        <div className="about-me-bx">
                            <h4>Wie ben ik?</h4>
                            <CodeBlock />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
